import script from "./ProjectNotes.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectNotes.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectNotes.vue?vue&type=style&index=0&id=3631c342&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3631c342"]])

export default __exports__